import "./Landholding.css";

import { OrganisationTypeConstants } from "../../../constants";
import { FileType } from "../../../models";
import { LandholdingWithTabsTemplate } from "../../../templates/LandholdingWithTabsTemplate";
import { distinctBy } from "../../../utils";
import { ProfileMenu, ProfileMenuItem, QuickActionsButton, QuickActionsMenu } from "../../../widget";
import { useLandholding } from "./useLandholding";

const Landholding = (): JSX.Element => {
  const {
    landholdingUuid,
    handleBackClick,
    tabsList,
    backButtonText,
    landholdingDetails,
    publicLandholdingDetails,
    projectsChartData,
    areaChartData,
    projectsChartColours,
    areaChartColours,
    isInventoryChartLoading,
    inventoryChartData,
    selectedStatuses,
    handleStatusFilter,
    hasFullProjectAccess,
    selectedUnitMeasurementData,
    updateInventoryChartData,
    unitMeasurementDropDownData,
    currentUserType,
    readGroupProjectsPermission,
    quickActionsMenuOptionsList,
    showQuickActionsMenu,
    setShowQuickActionsMenu,
    publicProjectsDevelopers,
  } = useLandholding();

  // Developer and Verifier landholding pages keep the original quick actions menu.
  const legacyQuickActions =
    quickActionsMenuOptionsList.length > 0 ? (
      <div>
        <QuickActionsMenu onClick={() => setShowQuickActionsMenu(true)} />
        <ProfileMenu show={showQuickActionsMenu} onClose={() => setShowQuickActionsMenu(false)} position={{ top: "0" }}>
          {quickActionsMenuOptionsList.map((el) => (
            <ProfileMenuItem
              key={el.id}
              profileMenuItem={el}
              onClick={() => {
                if (el.action) {
                  el.action();
                }
                setShowQuickActionsMenu(false);
              }}
            />
          ))}
        </ProfileMenu>
      </div>
    ) : undefined;

  return (
    <LandholdingWithTabsTemplate
      activeElement="Projects"
      landholdingUuid={landholdingUuid}
      pageTitle={landholdingDetails?.groupName ?? publicLandholdingDetails?.groupName}
      tabsList={tabsList}
      developers={
        landholdingDetails?.projects
          ? distinctBy(
              (landholdingDetails.projects || [])
                .map((project) => ({
                  name: project.developer?.displayName ?? undefined,
                  icon: project.developer?.files.find((file) => file.type === FileType.SmallLogo)?.file.url,
                }))
                .filter((developer): developer is { name: string; icon: string | undefined } => !!developer.name),
              (developer) => developer.name
            )
          : publicProjectsDevelopers
      }
      addressCountryCode={
        landholdingDetails?.projects?.[0]?.addressCountryCode ??
        publicLandholdingDetails?.projects?.[0]?.addressCountryCode ??
        undefined
      }
      selectedStatuses={selectedStatuses}
      onStatusesChange={handleStatusFilter}
      hasFullProjectAccess={hasFullProjectAccess}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
      quickActions={
        currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? (
          <QuickActionsButton
            options={quickActionsMenuOptionsList}
            showMenu={showQuickActionsMenu}
            setShowMenu={setShowQuickActionsMenu}
          />
        ) : (
          legacyQuickActions
        )
      }
      projectsChartData={projectsChartData}
      areaChartData={areaChartData}
      projectsChartColours={projectsChartColours}
      areaChartColours={areaChartColours}
      isInventoryChartLoading={isInventoryChartLoading}
      inventoryChartData={inventoryChartData}
      selectedUnitMeasurementData={selectedUnitMeasurementData}
      updateInventoryChartData={updateInventoryChartData}
      unitMeasurementDropDownData={unitMeasurementDropDownData}
      currentUserType={currentUserType}
      readGroupProjectsPermission={readGroupProjectsPermission}
    />
  );
};

export default Landholding;
